import { ChangeDetectionStrategy, Component, EventEmitter, Inject, Output } from '@angular/core';
import { MatLegacyDialogRef, MAT_LEGACY_DIALOG_DATA } from '@angular/material/legacy-dialog';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { OrgTypes } from '@mode/shared/contract-common';

export interface EmailAdminDialogData {
  admins$: Observable<ReadonlyArray<OrgTypes.Admin>>;
  confirmAction?: (form: EmailAdminDialogForm) => void;
}

interface EmailAdminDialogForm {
  adminId: number;
  message: string;
}

@Component({
  selector: 'mode-email-admin-dialog',
  templateUrl: './email-admin-dialog.component.html',
  styleUrls: ['./email-admin-dialog.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class EmailAdminDialogComponent {
  @Output() sendEmail = new EventEmitter<EmailAdminDialogForm>();
  public defaultAdmin$ = this.data.admins$.pipe(map((admins) => admins?.[0]?.id));
  public readonly defaultMessage =
    "I'd like to connect data to our Workspace, but only admins " +
    'have permission to add a new data connection. Can you help?';
  constructor(
    @Inject(MAT_LEGACY_DIALOG_DATA)
    public data: EmailAdminDialogData,
    public dialogRef: MatLegacyDialogRef<EmailAdminDialogComponent>
  ) {}

  public onSendEmail(form: EmailAdminDialogForm): void {
    this.sendEmail.emit(form);
    this.dialogRef.close();
  }
}
